var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_545_1769",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_545_1769",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC7klEQVR4nO2dSW4UQRBFS72wBCdwswJ8CWABhhvZcAebLYO64CSMvgWGA9AsDGIGs3sopWRFDV1j/oyOJ7VkWeWq/7/TmR3RUrgoMgC4DTwF3gI/4yt8/QTYT60ve4A94DXtvASupNabJcAN4BOb8xG4nlp3VgCXgTO6E34xe6n1ZwPwiv6cpNafBcAdhuMHZBvx3UUV58ABsAssgcP4vSrK1gdtO8C7mvAOKq69W3PtaRr1GQH8qAlvt+LasLqr+F5Yp6K4GItlxbPCFjIWeRRBHYqLvhxWPPMe06FXBPUoLvpwHg/AZXyF/fkP06JTBA0oLnJBowgaWFzkwomF4iIX9qWLix73HIUez9UtgroUF5uSKmjpIqhLcZFR0HpF0NgmA8B6hJzfF2K+FIM+HiHoIzVfikHvxLD7rOx1/NkdNV+FKUFWfckJsupLTpBVX3KCrPqSE2TVl5wgq77kBFn1JSfIqi85QVZ9yQmy6ktOkFVfcoKs+hoiCLgIPAa+0p0vwCPgQktz6j7woWuzyVrQJcMpO7Zbj6f2NQl9BQEL4PcIQf8K96p5RlWbdT2lr8nwoGdCYOtYddw6jrZqRQfCQQY8jAdbVz4DDzY4DP99UrO9h6Eycr7kBFn1JSfIqi85QVZ9yQmy6ktOkFVfQwThvY7Zgi4Zjvc6WkJeeK9jhhWNB53d1rFquL/3OgLe65hpRSsj50tOkFVfcoKs+pITZNWXnCCrvuQEWfU1RBDe65gt6JLheK+jJeSF9zpmWNF40NltHauG+3uvI+C9jplWtDJyvuQEWfUlJ8iqLzlBVn3JCbLqS06QVV9ygqz6khNk1ZecIKu+woiyscexpQa4VOPpm+KAwf9GEOdCw6jkpAMGw1DrxhHERSbQPip5lXr6+bZwM1nQMewX2OdZ0pC3aFD31UKBMJ49jmm3xhlwrVAi/OMBY9vI8/DXWqgC3IofU502jD1WJGh9E95dJD/4HMdxHMdxHMdxihn5CzVK/oyhF7HoAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateReportIcon);
export default __webpack_public_path__ + "static/media/generateReportIcon.cf6bbee1c012587eb842c850f32a435a.svg";
export { ForwardRef as ReactComponent };